import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: "aen", // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

const state = {
  appTitle: "aen",
  appVersion: "0.0.1",
  auth: {
    token: "",
    expires: 0,
    role: "",
  },
};

const getters = {
  isLoggedIn: (state) => {
    return state.auth.token && state.auth.expires > Date.now();
  },
  role: (state) => {
    return state.auth.role;
  },
};

const mutations = {
  login(state, { token, expires, role }) {
    state.auth.token = token;
    state.auth.expires = expires;
    state.auth.role = role || "author";
  },
  logout(state) {
    state.auth.token = "";
    state.auth.expires = 0;
    state.auth.role = "";
  },
};

const actions = {
  login({ commit }, payload) {
    commit("login", payload);
  },
  logout({ commit }) {
    commit("logout");
  },
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [vuexLocalStorage.plugin],
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js